const ACTIONS = {
  PUBLICATION_SWITCHED: "PUBLICATION_SWITCHED",
};

export default ACTIONS;



// WEBPACK FOOTER //
// ./src/common/utilities/eventBusActions.js